import Loadable from "@loadable/component";

const EntryPage = Loadable(
  () => import(/* webpackChunkName: "entry_page" */ "./entryPage")
);

export default EntryPage;
